import { Typography, TypographyProps } from "@mui/material";

interface Props extends TypographyProps {
  letterSpacing?: number | string;
}

export const Text = ({ letterSpacing, ...props }: Props) => {
  const letterSpacingEm =
    typeof letterSpacing === "number"
      ? `${letterSpacing / 1000}em`
      : letterSpacing;
  return (
    <Typography {...props} sx={{ letterSpacing: letterSpacingEm, ...props.sx }}>
      {props.children}
    </Typography>
  );
};
